import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Directive, Output, HostBinding, HostListener, Component, ViewChild, NgModule } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environment-configurations';
import * as i1$1 from 'primeng/api';
import * as i4 from 'custom-button-action';
import * as i5 from 'bulk-upload-dashboard';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/dropdown';
import * as i8 from 'primeng/dialog';
import * as i9 from 'primeng/radiobutton';
import * as i11 from 'primeng/button';
import * as i12 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';
import { PdfViewerModule } from 'ng2-pdf-viewer';

class NewTalentUploadService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.radioValue = new Subject();
        this.parsingDocValues = new Subject();
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    sendParsingDocValues(value) {
        this.parsingDocValues.next({ details: value });
    }
    getParsingDocValues() {
        return this.parsingDocValues.asObservable();
    }
    sendRadioChange(value) {
        this.radioValue.next({ radio: value });
    }
    getRadioChange() {
        return this.radioValue.asObservable();
    }
    getSupplierList() {
        return this.httpClient.get(`/vd/formBuilder/get/supplierList/info`);
    }
    getSource() {
        return this.httpClient.get(`/referenceLibrary/TPAPPLICANTSOURCES`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getDeptDetails() {
        return this.httpClient.get(`/vd/dataSource/FBDEPARTMENTBYCOMPANYID/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getPositionDetails() {
        return this.httpClient.get(`/vd/dataSource/FB_ONB_JOB_POSITION/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getJobIdDetails(jobId) {
        return this.httpClient.get(`/vd/fb/get/talentAcq/jobPosition/${jobId}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    uploadDocument(payload) {
        return this.httpClient.post(`/vd/fb/upload/talentAcq/applicant/resume`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    parsingDocument(payload) {
        return this.httpClient.post(`/uploadAddApplicantResume?applicantSourceRefCode=CAREERPORTAL`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadDocuments(path, fileName, fileType) {
        this.httpClient.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    requestSend(payload) {
        return this.httpClient.post(`/vd/fb/save/talentAcq/eMail/applicant`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    delete(Id) {
        return this.httpClient.delete(`/vd/fb/delete/talentAcq/applicant/docId/${Id}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
}
NewTalentUploadService.ɵfac = function NewTalentUploadService_Factory(t) { return new (t || NewTalentUploadService)(i0.ɵɵinject(i1.HttpClient)); };
NewTalentUploadService.ɵprov = i0.ɵɵdefineInjectable({ token: NewTalentUploadService, factory: NewTalentUploadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NewTalentUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class FileDragNDropDirective {
    constructor() {
        //@Input() private allowed_extensions : Array<string> = ['png', 'jpg', 'bmp'];
        this.filesChangeEmiter = new EventEmitter();
        //@Output() private filesInvalidEmiter : EventEmitter<File[]> = new EventEmitter();
        this.background = '#E8F5FB';
        this.borderStyle = '2px dashed';
        this.borderColor = '#1AA0DA';
        this.borderRadius = '5px';
    }
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
    onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let files = evt.dataTransfer.files;
        let valid_files = files;
        this.filesChangeEmiter.emit(valid_files);
    }
}
FileDragNDropDirective.ɵfac = function FileDragNDropDirective_Factory(t) { return new (t || FileDragNDropDirective)(); };
FileDragNDropDirective.ɵdir = i0.ɵɵdefineDirective({ type: FileDragNDropDirective, selectors: [["", "fileDragDrop", ""]], hostVars: 8, hostBindings: function FileDragNDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dragover", function FileDragNDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function FileDragNDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function FileDragNDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
    } if (rf & 2) {
        i0.ɵɵstyleProp("background", ctx.background)("border", ctx.borderStyle)("border-color", ctx.borderColor)("border-radius", ctx.borderRadius);
    } }, outputs: { filesChangeEmiter: "filesChangeEmiter" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDragNDropDirective, [{
        type: Directive,
        args: [{
                selector: '[fileDragDrop]'
            }]
    }], function () { return []; }, { filesChangeEmiter: [{
            type: Output
        }], background: [{
            type: HostBinding,
            args: ['style.background']
        }], borderStyle: [{
            type: HostBinding,
            args: ['style.border']
        }], borderColor: [{
            type: HostBinding,
            args: ['style.border-color']
        }], borderRadius: [{
            type: HostBinding,
            args: ['style.border-radius']
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

const _c0 = ["fileInput"];
function NewTalentUploadComponent_p_radioButton_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 21);
    i0.ɵɵlistener("onClick", function NewTalentUploadComponent_p_radioButton_6_Template_p_radioButton_onClick_0_listener() { i0.ɵɵrestoreView(_r12); const i_r10 = ctx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.radioChange(i_r10.value); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", i_r10.value)("label", i_r10.label)("inputId", i_r10.inputId);
} }
function NewTalentUploadComponent_div_10_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Name is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_10_div_4_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.f.name.errors.required);
} }
const _c1 = function (a0) { return { "is-invalid": a0 }; };
function NewTalentUploadComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "p", 10);
    i0.ɵɵtext(2, "Name of the Applicant");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 23);
    i0.ɵɵtemplate(4, NewTalentUploadComponent_div_10_div_4_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r1.submitted && ctx_r1.f.name.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.f.name.errors);
} }
function NewTalentUploadComponent_div_11_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Email ID is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_11_div_4_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.f.emailId.errors.required);
} }
function NewTalentUploadComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "p", 10);
    i0.ɵɵtext(2, "Email ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 26);
    i0.ɵɵtemplate(4, NewTalentUploadComponent_div_11_div_4_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r2.submitted && ctx_r2.f.emailId.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.submitted && ctx_r2.f.emailId.errors);
} }
function NewTalentUploadComponent_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Source is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Source is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_16_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵtemplate(2, NewTalentUploadComponent_div_16_div_2_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.f.source.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.f.source.errors.touched);
} }
function NewTalentUploadComponent_div_17_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Supplier is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_17_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Supplier is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_17_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_17_div_4_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵtemplate(2, NewTalentUploadComponent_div_17_div_4_div_2_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.f.source.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.f.source.errors.touched);
} }
const _c2 = function () { return { "width": "100%" }; };
function NewTalentUploadComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "p", 10);
    i0.ɵɵtext(2, "Suppliers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 27);
    i0.ɵɵlistener("onChange", function NewTalentUploadComponent_div_17_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onChangeSupplier($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NewTalentUploadComponent_div_17_div_4_Template, 3, 2, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c2));
    i0.ɵɵproperty("options", ctx_r4.supplierList)("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r4.submitted && ctx_r4.f.source.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.submitted && ctx_r4.f.source.errors);
} }
function NewTalentUploadComponent_div_19_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Position is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_19_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_19_div_4_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.f.position.errors.required);
} }
function NewTalentUploadComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "p", 10);
    i0.ɵɵtext(2, "Position");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 28);
    i0.ɵɵlistener("onChange", function NewTalentUploadComponent_div_19_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.onPositionChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NewTalentUploadComponent_div_19_div_4_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c2));
    i0.ɵɵproperty("options", ctx_r5.getPositionDetails)("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r5.submitted && ctx_r5.f.position.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.submitted && ctx_r5.f.position.errors);
} }
function NewTalentUploadComponent_div_20_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Job ID is required");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_20_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, NewTalentUploadComponent_div_20_div_4_div_1_Template, 2, 0, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.f.jobId.errors.required);
} }
function NewTalentUploadComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "p", 10);
    i0.ɵɵtext(2, "Job ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 29);
    i0.ɵɵlistener("onChange", function NewTalentUploadComponent_div_20_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.onJobIdChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NewTalentUploadComponent_div_20_div_4_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(5, _c2));
    i0.ɵɵproperty("options", ctx_r6.getJobIdDetails)("disabled", ctx_r6.enableJobId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.submitted && ctx_r6.f.jobId.errors);
} }
function NewTalentUploadComponent_div_21_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1, "(Supported file type: doc, docx, pdf)");
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_21_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1, "(To upload another resume, first delete the resume below)");
    i0.ɵɵelementEnd();
} }
const _c3 = function (a0) { return { "inactive": a0 }; };
function NewTalentUploadComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "h2");
    i0.ɵɵtext(2, "Upload Your Resume/CV");
    i0.ɵɵelementStart(3, "sup");
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "div", 31);
    i0.ɵɵlistener("filesChangeEmiter", function NewTalentUploadComponent_div_21_Template_div_filesChangeEmiter_6_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.FileUpload($event); });
    i0.ɵɵelementStart(7, "div", 32);
    i0.ɵɵelementStart(8, "div", 33);
    i0.ɵɵelementStart(9, "input", 34, 35);
    i0.ɵɵlistener("change", function NewTalentUploadComponent_div_21_Template_input_change_9_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.FileUpload($event.target.files); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "span", 36);
    i0.ɵɵtext(12, "Drop your file here or ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 37);
    i0.ɵɵtext(14, "Browse");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, NewTalentUploadComponent_div_21_span_15_Template, 2, 0, "span", 38);
    i0.ɵɵtemplate(16, NewTalentUploadComponent_div_21_span_16_Template, 2, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("disabled", ctx_r7.fileDialogShouldOpen == false);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, !ctx_r7.fileDialogShouldOpen));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.fileDialogShouldOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.fileDialogShouldOpen);
} }
function NewTalentUploadComponent_div_22_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "button", 49);
    i0.ɵɵlistener("click", function NewTalentUploadComponent_div_22_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return ctx_r39.viewResume(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function NewTalentUploadComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "p", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 42);
    i0.ɵɵelementStart(4, "div", 43);
    i0.ɵɵtemplate(5, NewTalentUploadComponent_div_22_div_5_Template, 2, 0, "div", 44);
    i0.ɵɵelementStart(6, "div", 45);
    i0.ɵɵelementStart(7, "button", 46);
    i0.ɵɵlistener("click", function NewTalentUploadComponent_div_22_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.DownloadResume(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 45);
    i0.ɵɵelementStart(9, "button", 47);
    i0.ɵɵlistener("click", function NewTalentUploadComponent_div_22_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r42); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.deleteConfirm(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.uploadedFiles == null ? null : ctx_r8.uploadedFiles.fileName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r8.fileFormat == "pdf");
} }
function NewTalentUploadComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 50);
    i0.ɵɵelementStart(2, "button", 51);
    i0.ɵɵlistener("click", function NewTalentUploadComponent_div_23_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.requestSend(); });
    i0.ɵɵtext(3, " Request Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 52);
    i0.ɵɵelementStart(5, "button", 53);
    i0.ɵɵlistener("click", function NewTalentUploadComponent_div_23_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.cancel(); });
    i0.ɵɵtext(6, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c4 = function () { return { width: "50vw" }; };
class NewTalentUploadComponent {
    constructor(primengConfig, fb, newTalentUploadService, customButtonActionService, bulkUploadDashboardService) {
        this.primengConfig = primengConfig;
        this.fb = fb;
        this.newTalentUploadService = newTalentUploadService;
        this.customButtonActionService = customButtonActionService;
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.observableSubscription$ = new Subject();
        this.fileFormat = "";
        this.getJobIdDetails = [];
        this.getDeptDetails = [];
        this.getPositionDetails = [];
        this.radios = [{
                label: "Add full Applicant details manually",
                value: "Manual",
                inputId: 1
            }, {
                label: "Request Applicant to provide full details",
                value: "Full",
                inputId: 2
            }];
        this.files = [];
        this.submitted = false;
        this.getDisplayFlag = false;
        this.enableJobId = true;
        this.getSourceDetails = [];
        this.subscription = [];
        this.fileFlag = true;
        this.showLoader = false;
        this.fileDialogShouldOpen = true;
        this.showSuppliersList = false;
    }
    ngOnInit() {
        this.individualForm = this.fb.group({
            radioValue: [this.radios[0].value],
            name: ['', Validators.required],
            emailId: ['', Validators.required],
            source: ['', Validators.required],
            supplier: [''],
            position: ['', Validators.required],
            jobId: ['', Validators.required]
        });
        this.getSources();
        this.getDept();
        this.getPosition();
        this.individualForm.valueChanges.subscribe(e => {
            this.individualForm.setValue(e, { emitEvent: false });
        });
        this.primengConfig.ripple = true;
        this.bulkUploadDashboardService.editFlowflag = 'parsing_details';
    }
    getSources() {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getSource()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.getSourceDetails = response.data;
        });
    }
    getSuppliers() {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getSupplierList()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status == 200) {
                this.supplierList = response.data;
            }
        });
    }
    get f() {
        return this.individualForm.controls;
    }
    onChangeSupplier(e) {
        var _a;
        this.selectedSupplier = e.value;
        const selectedSupplier = this.supplierList.find(supplier => supplier.supplierId === this.selectedSupplier);
        if (selectedSupplier) {
            this.supplierId = selectedSupplier.supplierId;
            this.supplierName = selectedSupplier.supplierName;
            sessionStorage.setItem('getSupplierValue', JSON.stringify(this.supplierId));
            sessionStorage.setItem('getSupplierNameValue', JSON.stringify(this.supplierName));
            (_a = this.individualForm.get('templateId')) === null || _a === void 0 ? void 0 : _a.setValue(this.supplierId);
        }
    }
    radioChange(item) {
        if (item == "Manual") {
            this.fileFlag = true;
        }
        else {
            this.fileFormat = 'pdf';
            this.fileFlag = false;
        }
        this.getDisplayFlag = false;
        if (this.getDisplayFlag) {
            this.newTalentUploadService.sendRadioChange(item);
        }
        else if (this.getDisplayFlag && item == "Manual") {
            this.newTalentUploadService.sendRadioChange(item);
        }
        else {
            this.newTalentUploadService.sendRadioChange(null);
            this.enableJobId = true;
        }
    }
    onJobIdChange(data) {
        this.getJobIdPayload = data.value;
    }
    onPositionChange(data) {
        this.getJobId(data.value);
        this.getJobTitlePayload = data.value;
    }
    onSourceChange(data) {
        this.source = this.getSourceDetails.filter(x => x.id == data.value);
        sessionStorage.setItem('getSourceValue', JSON.stringify(this.source[0]));
        if (this.source[0].code === 'SUPPLIER') {
            this.showSuppliersList = true;
            this.getSuppliers();
        }
        else {
            this.showSuppliersList = false;
        }
    }
    requestSend() {
        this.submitted = true;
        if (this.individualForm.invalid) {
            return;
        }
        const payload = {
            "applicantEmailId": this.individualForm.get('emailId').value ? this.individualForm.get('emailId').value : "",
            "applicantName": this.individualForm.get('name').value ? this.individualForm.get('name').value : "",
            "applicantSource": {
                "code": this.source[0].code,
                "createdBy": 0,
                "description": this.source[0].desc,
                "group": this.source[0].group,
                "id": this.source[0].id,
                "isVisible": 0,
                "modifiedBy": 0,
                "name": this.source.name,
                "refGroupdesc": "string"
            },
            "jobId": this.getJobIdPayload,
            "jobTitle": this.getJobTitlePayload,
            "supplierId": this.supplierId,
            "supplierName": this.supplierName,
        };
        this.subscription[this.subscription.length] = this.newTalentUploadService.requestSend(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.cancel();
            }
        });
    }
    getJobId(jobId) {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getJobIdDetails(jobId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getJobIdDetails = response.data;
                this.enableJobId = false;
            }
        });
    }
    getDept() {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getDeptDetails()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getDeptDetails = response.data;
            }
        });
    }
    getPosition() {
        this.subscription[this.subscription.length] = this.newTalentUploadService.getPositionDetails()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.getPositionDetails = response.data;
            }
        });
    }
    cancel() {
        var parentPageFormIdpageFormId = parseInt(sessionStorage.getItem("parentPageFormId"));
        var pageFormId;
        if (parentPageFormIdpageFormId) {
            pageFormId = parentPageFormIdpageFormId;
            sessionStorage.setItem('backtojobopening', sessionStorage.getItem('true'));
            sessionStorage.setItem('idToGetDetails', sessionStorage.getItem('selectedjobposition'));
            sessionStorage.setItem('AttendanceDataId', sessionStorage.getItem('selectedjobposition'));
            sessionStorage.setItem('fbFormDataDTO', sessionStorage.getItem('selectedjobpositionfbFormDataDTO'));
        }
        else {
            var pageFormId = JSON.parse(sessionStorage.getItem("selectedMenu"));
            pageFormId = pageFormId.pageFormId;
        }
        if (pageFormId) {
            this.customButtonActionService.getPageFormById(pageFormId)
                .pipe(take(1)).subscribe((response) => {
                if (response) {
                    const item = {
                        formType: response.buildFormatTypeId,
                        pageFormId: response.id
                    };
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
            });
        }
    }
    deleteConfirm() {
        this.displayBasic = true;
    }
    deleteResume() {
        const id = this.uploadedFiles.id;
        this.subscription[this.subscription.length] = this.newTalentUploadService.delete(id)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data == null) {
                this.fileInput.nativeElement.value = null;
                this.newTalentUploadService.sendRadioChange("Full");
                this.getDisplayFlag = false;
                this.displayBasic = false;
                this.fileDialogShouldOpen = true;
            }
        });
    }
    viewResume() {
        const path = environment.docs + this.uploadedFiles.fileLocation.replace('/var/imagility/uploads/', '');
        window.open(`${path}`, "_blank");
    }
    DownloadResume() {
        const path = environment.docs + this.uploadedFiles.fileLocation.replace('/var/imagility/uploads/', '');
        if (this.fileFormat == 'pdf') {
            this.newTalentUploadService.downloadDocuments(path, "Resume", this.uploadedFiles.fileType);
        }
        else {
            window.open(`${path}`, "_blank");
        }
        //window.open(`${path}`, "_blank");
    }
    onFileChange(pFileList) {
        this.files = Object.keys(pFileList).map(key => pFileList[key]);
    }
    FileUpload(event) {
        const payload = new FormData();
        const file = event[0];
        this.newTalentUploadService.getDocData = event[0];
        payload.append('file', file);
        payload.append("applicantSourceRefCode", "TALENTPOOL");
        this.fileName = event[0].name;
        if (this.fileDialogShouldOpen) {
            this.subscription[this.subscription.length] = this.newTalentUploadService.uploadDocument(payload)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response.data) {
                    this.uploadedFiles = response.data;
                    sessionStorage.setItem('uploadedFileName', this.uploadedFiles.fileName);
                    this.fileFormat = this.uploadedFiles.fileType;
                    if (this.fileFormat == 'pdf' || this.fileFormat == 'doc' || this.fileFormat == 'docx') {
                        this.newTalentUploadService.getDocId = response.data.id;
                        //sessionStorage.setItem('resumePayload', JSON.stringify(payload));
                        payload.delete("applicantSourceRefCode");
                        //payload.append("applicantSourceRefCode", "TALENTPOOL");
                        this.subscription[this.subscription.length] = this.newTalentUploadService.parsingDocument(payload)
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((response) => {
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                this.getDisplayFlag = true;
                                this.fileDialogShouldOpen = false;
                                this.newTalentUploadService.sendRadioChange(this.radios[0].value);
                                this.getParsingDocData = response.data;
                                this.newTalentUploadService.sendParsingDocValues(this.getParsingDocData);
                            }
                        });
                    }
                    else {
                        this.getDisplayFlag = false;
                    }
                }
            });
        }
    }
}
NewTalentUploadComponent.ɵfac = function NewTalentUploadComponent_Factory(t) { return new (t || NewTalentUploadComponent)(i0.ɵɵdirectiveInject(i1$1.PrimeNGConfig), i0.ɵɵdirectiveInject(i2.FormBuilder), i0.ɵɵdirectiveInject(NewTalentUploadService), i0.ɵɵdirectiveInject(i4.CustomButtonActionService), i0.ɵɵdirectiveInject(i5.BulkUploadDashboardService)); };
NewTalentUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: NewTalentUploadComponent, selectors: [["new-talent-upload"]], viewQuery: function NewTalentUploadComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
    } }, decls: 34, vars: 26, consts: [[1, "row", "individual_upload_container", "p-2"], [1, "col-12", "upload_section", "pb-3", "mb-3", 3, "formGroup", "ngSubmit"], [1, "w-600"], [1, ""], ["class", "mr-4 mb-3 mt-3", "name", "fileFormat", "formControlName", "radioValue", 3, "value", "label", "inputId", "onClick", 4, "ngFor", "ngForOf"], [1, "w-600", "col-12"], [1, "row"], ["class", "col-3 pl-0", 4, "ngIf"], ["class", "col-3", 4, "ngIf"], [1, "col-3"], [1, "label-cls"], ["formControlName", "source", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass", "onChange"], ["class", "invalid-feedback", 4, "ngIf"], [1, "row", "mt-3"], ["class", "mb-3 mt-3 text-center", 4, "ngIf"], ["class", "resume_actions row", 4, "ngIf"], ["class", "row mt-4", 4, "ngIf"], ["header", "Confirm", 3, "visible", "modal", "baseZIndex", "draggable", "resizable", "visibleChange"], [1, "row", "mt-4"], ["type", "button", 1, "btn", "btn-success", "button-width-icon-left", "mr-3", 3, "click"], ["type", "button", 1, "btn", "border-secondary", "text-secondary", "button-width-icon-left", "mr-3", 3, "click"], ["name", "fileFormat", "formControlName", "radioValue", 1, "mr-4", "mb-3", "mt-3", 3, "value", "label", "inputId", "onClick"], [1, "col-3", "pl-0"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "name", "placeholder", "Enter", 1, "im-input", "form-control", 3, "ngClass"], [1, "invalid-feedback"], [4, "ngIf"], ["type", "text", "pattern", "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$", "formControlName", "emailId", "placeholder", "Enter", 1, "im-input", "form-control", 3, "ngClass"], ["formControlName", "supplier", "optionLabel", "supplierName", "optionValue", "supplierId", "placeholder", "Select Supplier", 3, "options", "ngClass", "onChange"], ["formControlName", "position", "optionLabel", "name", "optionValue", "id", "placeholder", "Select", 3, "options", "ngClass", "onChange"], ["formControlName", "jobId", "optionLabel", "jobPosition", "optionValue", "id", "placeholder", "Select", 3, "options", "disabled", "onChange"], [1, "mb-3", "mt-3", "text-center"], ["fileDragDrop", "", 1, "dropzone", 3, "filesChangeEmiter"], [1, "text-wrapper"], [1, "centered"], ["type", "file", "name", "file", "id", "fileInput", 3, "disabled", "change"], ["fileInput", ""], [1, "textLink"], ["for", "fileInput", 1, "browse", 3, "ngClass"], ["class", "text-gray-500", 4, "ngIf"], [1, "text-gray-500"], [1, "resume_actions", "row"], [1, "col-9"], [1, "col-3", "text-right"], [1, "row", "text-right", "p-2"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0", "d-inline-block"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "click"], [1, "mr-2", "padding0"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "click"], [1, "col-8"], ["type", "submit", 1, "btn", "btn-success", "button-width-icon-left", "mr-3", 3, "click"], [1, "col-2"], ["type", "submit", 1, "btn", "btn-secondary", "button-width-icon-left", "mr-3", 3, "click"]], template: function NewTalentUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵlistener("ngSubmit", function NewTalentUploadComponent_Template_div_ngSubmit_1_listener() { return ctx.requestSend(); });
        i0.ɵɵelementStart(2, "h6", 2);
        i0.ɵɵtext(3, "How do you want to include a New Applicant?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵtemplate(6, NewTalentUploadComponent_p_radioButton_6_Template, 1, 3, "p-radioButton", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "h5", 5);
        i0.ɵɵtext(8, "Applicant Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, NewTalentUploadComponent_div_10_Template, 5, 4, "div", 7);
        i0.ɵɵtemplate(11, NewTalentUploadComponent_div_11_Template, 5, 4, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelementStart(13, "p", 10);
        i0.ɵɵtext(14, "Sources");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p-dropdown", 11);
        i0.ɵɵlistener("onChange", function NewTalentUploadComponent_Template_p_dropdown_onChange_15_listener($event) { return ctx.onSourceChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, NewTalentUploadComponent_div_16_Template, 3, 2, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, NewTalentUploadComponent_div_17_Template, 5, 8, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵtemplate(19, NewTalentUploadComponent_div_19_Template, 5, 8, "div", 7);
        i0.ɵɵtemplate(20, NewTalentUploadComponent_div_20_Template, 5, 6, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, NewTalentUploadComponent_div_21_Template, 17, 6, "div", 14);
        i0.ɵɵtemplate(22, NewTalentUploadComponent_div_22_Template, 10, 2, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(23, NewTalentUploadComponent_div_23_Template, 7, 0, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "p-dialog", 17);
        i0.ɵɵlistener("visibleChange", function NewTalentUploadComponent_Template_p_dialog_visibleChange_24_listener($event) { return ctx.displayBasic = $event; });
        i0.ɵɵelementStart(25, "p");
        i0.ɵɵtext(26, "Do you really want to delete this file?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 18);
        i0.ɵɵelementStart(28, "div");
        i0.ɵɵelementStart(29, "button", 19);
        i0.ɵɵlistener("click", function NewTalentUploadComponent_Template_button_click_29_listener() { return ctx.deleteResume(); });
        i0.ɵɵtext(30, " Yes ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div");
        i0.ɵɵelementStart(32, "button", 20);
        i0.ɵɵlistener("click", function NewTalentUploadComponent_Template_button_click_32_listener() { return ctx.displayBasic = false; });
        i0.ɵɵtext(33, " No ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.individualForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.radios);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.fileFlag);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(22, _c2));
        i0.ɵɵproperty("options", ctx.getSourceDetails)("ngClass", i0.ɵɵpureFunction1(23, _c1, ctx.submitted && ctx.f.source.errors));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.submitted && ctx.f.source.errors);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSuppliersList);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.getDisplayFlag && ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(25, _c4));
        i0.ɵɵproperty("visible", ctx.displayBasic)("modal", true)("baseZIndex", 10000)("draggable", false)("resizable", false);
    } }, directives: [i2.NgControlStatusGroup, i2.FormGroupDirective, i6.NgForOf, i6.NgIf, i7.Dropdown, i2.NgControlStatus, i2.FormControlName, i6.NgClass, i8.Dialog, i9.RadioButton, i2.DefaultValueAccessor, i2.PatternValidator, FileDragNDropDirective, i11.ButtonDirective, i12.Tooltip], styles: [".individual_upload_container[_ngcontent-%COMP%]{border-bottom:2px dotted #ced4da}.resume_actions[_ngcontent-%COMP%]{background:#f5f7f7;border-radius:5px;padding:10px;align-items:center;margin-top:10px}.resume_actions[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-weight:600;color:#6c757d}sup[_ngcontent-%COMP%]{color:#c54545}h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-family:Roboto,Arial,sans-serif}.centered[_ngcontent-%COMP%]{font-family:sans-serif}.dropzone[_ngcontent-%COMP%]{height:150px;display:table;width:50%;margin:0 auto}input[type=file][_ngcontent-%COMP%]{display:none}.browse[_ngcontent-%COMP%], .textLink[_ngcontent-%COMP%]{font-size:22px!important}.text-gray-500[_ngcontent-%COMP%]{color:#adb5bd;font-size:14px;display:block}.browse[_ngcontent-%COMP%]{color:#1aa0da;cursor:pointer;pointer-events:all}.browse.inactive[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}.text-wrapper[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.centered[_ngcontent-%COMP%]{font-size:1.3em;text-align:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NewTalentUploadComponent, [{
        type: Component,
        args: [{
                selector: 'new-talent-upload',
                templateUrl: './new-talent-upload.component.html',
                styleUrls: ['./new-talent-upload.component.scss'],
            }]
    }], function () { return [{ type: i1$1.PrimeNGConfig }, { type: i2.FormBuilder }, { type: NewTalentUploadService }, { type: i4.CustomButtonActionService }, { type: i5.BulkUploadDashboardService }]; }, { fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: false }]
        }] }); })();

class NewTalentUploadModule {
}
NewTalentUploadModule.ɵfac = function NewTalentUploadModule_Factory(t) { return new (t || NewTalentUploadModule)(); };
NewTalentUploadModule.ɵmod = i0.ɵɵdefineNgModule({ type: NewTalentUploadModule });
NewTalentUploadModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule,
            PdfViewerModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NewTalentUploadModule, { declarations: [NewTalentUploadComponent, FileDragNDropDirective], imports: [ReactiveFormsModule,
        PrimengLibraryModule,
        PdfViewerModule], exports: [NewTalentUploadComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NewTalentUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [NewTalentUploadComponent, FileDragNDropDirective],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                    PdfViewerModule,
                ],
                exports: [NewTalentUploadComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of new-talent-upload
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NewTalentUploadComponent, NewTalentUploadModule, NewTalentUploadService };
//# sourceMappingURL=new-talent-upload.js.map
